(function () {
  'use strict';

  const node = document.getElementById("LSCustomNuclearVibeConfig");
  if (!node) return;

  let config;
  try {
    config = JSON.parse(node.textContent || '{}');
  } catch (error) {
    console.error('[Love Smiths] Invalid builder configuration:', error);
    return;
  }

  if (!config || !config.sectionId) return;

document.addEventListener("DOMContentLoaded", function() {
      function escapeHTML(value) {
        return String(value || "")
          .replaceAll("&", "&amp;")
          .replaceAll("<", "&lt;")
          .replaceAll(">", "&gt;")
          .replaceAll('"', "&quot;")
          .replaceAll("'", "&#039;");
      }

      /* ---------- Gallery ---------- */
      const thumbnails = document.querySelectorAll(".thumbnail");
      const mainBanner = document.getElementById("main-banner");

      function swapMainSrc(newSrc) {
        if (!mainBanner || !newSrc) return;

        mainBanner.classList.add("is-fading");

        const img = new Image();

        img.onload = () => {
          mainBanner.src = newSrc;
          mainBanner.srcset = newSrc;
          mainBanner.removeAttribute("sizes");
          requestAnimationFrame(() => mainBanner.classList.remove("is-fading"));
        };

        img.onerror = () => mainBanner.classList.remove("is-fading");
        img.src = newSrc;
      }

      thumbnails.forEach(t => {
        t.addEventListener("click", function() {
          thumbnails.forEach(x => x.classList.remove("selected"));
          this.classList.add("selected");
          swapMainSrc(this.getAttribute("data-large") || this.getAttribute("src"));
        });
      });

      
      /* ---------- Mobile swipe ---------- */
      (function() {
        if (!mainBanner) return;

        const thumbs = Array.from(document.querySelectorAll(".thumbnail"));
        if (!thumbs.length) return;

        let currentIndex = Math.max(0, thumbs.findIndex(el => el.classList.contains("selected")));
        if (currentIndex === -1) currentIndex = 0;

        let startX = 0;
        let startY = 0;
        let swiping = false;

        function goTo(idx) {
          currentIndex = (idx + thumbs.length) % thumbs.length;

          const t = thumbs[currentIndex];

          thumbs.forEach(x => x.classList.remove("selected"));
          t.classList.add("selected");

          const newSrc = t.getAttribute("data-large") || t.getAttribute("src");
          swapMainSrc(newSrc);
        }

        mainBanner.addEventListener("touchstart", (e) => {
          if (!e.touches || !e.touches.length) return;

          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          swiping = true;
        }, { passive: true });

        mainBanner.addEventListener("touchmove", (e) => {
          if (!swiping) return;

          const dx = e.touches[0].clientX - startX;
          const dy = e.touches[0].clientY - startY;

          if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
            e.preventDefault();
          }
        }, { passive: false });

        mainBanner.addEventListener("touchend", (e) => {
          if (!swiping) return;

          swiping = false;

          const dx = e.changedTouches[0].clientX - startX;
          const dy = e.changedTouches[0].clientY - startY;

          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) goTo(currentIndex + 1);
            else goTo(currentIndex - 1);
          }
        });
      })();

      /* ---------- Form ---------- */
      const form = document.getElementById(`product-form-${config.sectionId}`);
      if (!form) return;

      const hiddenInput = form.querySelector('input[name="id"]');
      const addToCartBtn = document.getElementById(`add-to-cart-${config.sectionId}`);
      const hint = document.getElementById(`selection-hint-${config.sectionId}`);
      const defaultHintText = hint ? hint.textContent.trim() : "";

      const propFirmness = document.getElementById("prop-firmness");
      const propPour = document.getElementById("prop-pour-style");
      const propC1 = document.getElementById("prop-colour-1");
      const propC2 = document.getElementById("prop-colour-2");

      const customPanel = document.getElementById("customisation-panel");
      const pourInfoFrame = document.getElementById("pour-style-info-frame");
      const swatchSetsContainer = document.getElementById("swatch-sets");
      const prototype = document.getElementById("swatch-prototype");
      const swatchSource = document.getElementById("swatch-source");
      const livePreview = document.getElementById("live-preview");
      const instructionEl = document.getElementById("preview-instructions");
      const priceEls = document.querySelectorAll(".sticky-cart-price");
      const defaultPriceHTML = priceEls.length ? priceEls[0].innerHTML : "";

      const modelPreviewEl = document.getElementById("model-preview");
      const vibratorPreviewEl = document.getElementById("vibrator-preview");

      const optionCount = config.optionCount;

      const variants = Array.isArray(config.variants) ? config.variants : [];

      const availableVariants = (variants || []).filter(v => v && v.available);
      const optionBtns = form.querySelectorAll(".option-btn[data-variant='true']");
      const firmnessBtns = form.querySelectorAll(".btn-firmness");

      function setCartVisibility(showButton, hintText = defaultHintText) {
        if (addToCartBtn) {
          addToCartBtn.style.visibility = showButton ? "visible" : "hidden";
          addToCartBtn.style.pointerEvents = showButton ? "auto" : "none";
        }

        if (hint) {
          hint.hidden = showButton;

          if (!showButton && hintText) {
            hint.textContent = hintText;
          }
        }
      }

      function arraysEqualCI(a, b) {
        if (!a || !b || a.length !== b.length) return false;

        for (let i = 0; i < a.length; i++) {
          if (String(a[i] || "").toLowerCase() !== String(b[i] || "").toLowerCase()) {
            return false;
          }
        }

        return true;
      }

      function getSelectedVariantOptionsByIndex() {
        const selected = Array(optionCount).fill(null);

        form.querySelectorAll('.option-btn[data-variant="true"].active').forEach(btn => {
          const index = parseInt(btn.dataset.optionIndex || "", 10);

          if (!Number.isNaN(index) && index >= 0 && index < selected.length) {
            selected[index] = btn.dataset.value || "";
          }
        });

        return selected;
      }

      function selectedVariantOptionsAreComplete(selected) {
        return Array.isArray(selected) && selected.length === optionCount && selected.every(value => !!value);
      }

      function updateVariantId() {
        const selected = getSelectedVariantOptionsByIndex();

        if (!selectedVariantOptionsAreComplete(selected)) {
          hiddenInput.value = "";
          return;
        }

        const match = variants.find(v => arraysEqualCI(v.options, selected));
        hiddenInput.value = match ? match.id : "";
      }

      function variantMatchesProgressively(variant, selections, candidateIndex, candidateValue) {
        if (!variant || !variant.options) return false;

        // Model is independent. Colour count depends on Model. Vibrator Add-On
        // depends on Model + colour count. Later selections never lock earlier ones.
        for (let i = 0; i <= candidateIndex; i++) {
          const want = (i === candidateIndex) ? candidateValue : selections[i];
          if (!want) continue;

          const got = variant.options[i];
          if (String(got || "").toLowerCase() !== String(want || "").toLowerCase()) {
            return false;
          }
        }

        return true;
      }

      function isValueAvailableForIndex(optionIndex, value, selections) {
        return availableVariants.some(variant =>
          variantMatchesProgressively(variant, selections, optionIndex, value)
        );
      }

      function updateOptionAvailability() {
        let pass = 0;
        let clearedSelection = false;

        do {
          clearedSelection = false;
          const selections = getSelectedVariantOptionsByIndex();

          form.querySelectorAll('.option-btn[data-variant="true"]').forEach(btn => {
            const optionIndex = parseInt(btn.dataset.optionIndex || "", 10);
            if (Number.isNaN(optionIndex)) return;

            const value = btn.dataset.value || "";
            const ok = isValueAvailableForIndex(optionIndex, value, selections);

            btn.disabled = !ok;
            btn.classList.toggle("is-disabled", !ok);
            btn.setAttribute("aria-disabled", String(!ok));

            if (!ok && btn.classList.contains("active")) {
              btn.classList.remove("active");
              btn.setAttribute("aria-pressed", "false");
              clearedSelection = true;
            }
          });

          pass += 1;
        } while (clearedSelection && pass <= optionCount);

        updateVariantId();
      }

      function getActiveColourCountButton() {
        return form.querySelector('.option-btn[data-option-group="colorcount"].active');
      }

      function isSurpriseColourButton(button) {
        if (!button) return false;

        const raw = String(button.dataset.value || button.textContent || "").trim();

        // The regular choices contain 1 or 2. The translated Surprise choice
        // contains no number, so this remains language-independent.
        return raw !== "" && !/\d/.test(raw);
      }

      function isSurpriseSelected() {
        return isSurpriseColourButton(getActiveColourCountButton());
      }

      function getSelectedColourCount() {
        const countBtn = getActiveColourCountButton();

        if (!countBtn || isSurpriseColourButton(countBtn)) return 0;

        const raw = countBtn.dataset.value || countBtn.textContent || "";
        const m = raw.match(/\d+/);

        return m ? parseInt(m[0], 10) : 0;
      }

      function clearProperties() {
        propPour.value = "";
        propC1.value = "";
        propC2.value = "";
      }

      function hydrateSwatches(root) {
        const rows = root.querySelectorAll(".swatch-row");

        rows.forEach(row => {
          const candidates = row.querySelectorAll(".swatch");

          candidates.forEach(el => {
            const img = el.querySelector("img");
            const name =
              el.dataset?.colourName ||
              (img ? img.alt : "") ||
              (el.textContent || "").trim();

            if (!name) return;

            el.classList.add("swatch");

            if (!el.dataset.colourName) {
              el.dataset.colourName = name;
            }

            el.setAttribute("role", "button");

            if (!el.hasAttribute("aria-pressed")) {
              el.setAttribute("aria-pressed", "false");
            }
          });
        });
      }

      function makeSwatchSet(heading, maxSelect) {
        const clone = prototype.cloneNode(true);

        clone.removeAttribute("id");
        clone.style.display = "";
        clone.querySelector(".swatch-heading").textContent = heading;
        clone.dataset.maxSelect = maxSelect;

        const row = clone.querySelector(".swatch-row");
        row.innerHTML = "";

        if (swatchSource) {
          let subCats = swatchSource.querySelectorAll(".sub-swatch-category");

          if (!subCats.length) {
            subCats = swatchSource.querySelectorAll(".swatch");
          }

          if (subCats.length) {
            subCats.forEach(cat => {
              const catClone = cat.cloneNode(true);
              row.appendChild(catClone);
            });
          } else {
            const p = document.createElement("p");
            p.textContent = window.customizerStrings?.no_swatches_available || "";
            p.style.color = "#aaa";
            row.appendChild(p);
          }
        }

        hydrateSwatches(clone);

        return clone;
      }

      function updateLivePreview() {
        if (!livePreview) return;

        const selectedImgs = swatchSetsContainer.querySelectorAll(".swatch.active img");

        livePreview.innerHTML = "";

        const frag = document.createDocumentFragment();

        if (selectedImgs.length === 0) {
          const placeholder = document.createElement("div");
          placeholder.className = "preview-swatch";
          placeholder.innerHTML = `
            <img
              src="${config.placeholderUrl}"
              alt="${config.placeholderAlt}"
            >
          `;
          frag.appendChild(placeholder);
        } else {
          selectedImgs.forEach(img => {
            const wrapper = document.createElement("div");
            wrapper.className = "preview-swatch";
            wrapper.style.cursor = "pointer";

            const clone = img.cloneNode(true);
            wrapper.appendChild(clone);

            const colourName = img.alt || "";

            if (colourName) {
              const nameTag = document.createElement("span");
              nameTag.className = "preview-colour-name";
              nameTag.textContent = colourName;
              wrapper.appendChild(nameTag);
            }

            wrapper.addEventListener("click", () => {
              const firstSet = document.querySelector("#swatch-sets .swatch-set");
              if (!firstSet) return;

              if (window.expandSwatchSet) {
                window.expandSwatchSet(firstSet);
              }

              const activeSwatch = firstSet.querySelector(".swatch.active") || firstSet.querySelector(".swatch");
              const scrollTarget = activeSwatch || firstSet;

              scrollTarget.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
            });

            frag.appendChild(wrapper);
          });
        }

        livePreview.appendChild(frag);
      }

      function resetColourCustomisation() {
        customPanel.style.display = "none";
        pourInfoFrame.style.display = "none";
        swatchSetsContainer.innerHTML = "";
        clearProperties();
        updateLivePreview();
      }

      function renderSwatchSets(count) {
        if (isSurpriseSelected()) {
          resetColourCustomisation();
          return;
        }

        customPanel.style.display = "";
        swatchSetsContainer.innerHTML = "";

        clearProperties();
        updateLivePreview();

        if (count === 1) {
          pourInfoFrame.style.display = "none";
          swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_choose_one, 1));
          return;
        }

        if (count === 2) {
          pourInfoFrame.style.display = "";
          swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_choose_two_marble, 2));
          return;
        }

        pourInfoFrame.style.display = "none";
      }

      function renderOptionPreview(container, button) {
        if (!container) return;

        if (!button) {
          container.innerHTML = "";
          return;
        }

        const src = button.dataset.preview || "";
        const alt = button.dataset.previewAlt || window.customizerStrings?.variant_preview_alt || "";

        if (!src) {
          container.innerHTML = "";
          return;
        }

        container.innerHTML = `
          <img
            src="${escapeHTML(src)}"
            width="280"
            height="280"
            loading="lazy"
            alt="${escapeHTML(alt)}">
        `;
      }

      function updateVariantOptionPreviews() {
        const modelBtn = form.querySelector('.option-btn[data-option-group="model"].active');
        const vibratorBtn = form.querySelector('.option-btn[data-option-group="vibrator"].active');

        renderOptionPreview(modelPreviewEl, modelBtn);
        renderOptionPreview(vibratorPreviewEl, vibratorBtn);
      }

      function validate() {
        const hasVariant = !!hiddenInput.value;
        const hasFirmness = !!(propFirmness && propFirmness.value);
        const surpriseSelected = isSurpriseSelected();
        const count = getSelectedColourCount();
        const selectedSwatches = swatchSetsContainer.querySelectorAll(".swatch.active");
        const coloursOk = surpriseSelected || (count > 0 && selectedSwatches.length === count);

        clearProperties();

        if (!surpriseSelected && hasVariant && hasFirmness && coloursOk) {
          const allNames = [...selectedSwatches].map(sw =>
            sw.dataset.colourName || sw.querySelector("img")?.alt || ""
          );

          propC1.value = allNames[0] || "";
          propC2.value = allNames[1] || "";
          propPour.value = count > 1 ? window.customizerStrings.auto_marble_label : "";
        }

        const ok = hasVariant && hasFirmness && coloursOk;
        addToCartBtn.disabled = !ok;

        if (ok) {
          setCartVisibility(true);
        } else if (!hasVariant) {
          setCartVisibility(false, window.customizerStrings.validation_choose_all);
        } else if (!hasFirmness) {
          setCartVisibility(false, window.customizerStrings.validation_choose_firmness);
        } else {
          setCartVisibility(false, window.customizerStrings.validation_complete_colours);
        }

        if (instructionEl) {
          instructionEl.classList.remove("ready", "warning");

          if (!count) {
            instructionEl.textContent = window.customizerStrings.instr_start;
          } else if (count === 1) {
            instructionEl.textContent = coloursOk
              ? window.customizerStrings.instr_one_ready
              : window.customizerStrings.instr_one_pick;
            instructionEl.classList.add(coloursOk ? "ready" : "warning");
          } else if (count === 2) {
            instructionEl.textContent = coloursOk
              ? window.customizerStrings.instr_two_marble_ready
              : window.customizerStrings.instr_two_marble_pick;
            instructionEl.classList.add(coloursOk ? "ready" : "warning");
          }
        }
      }

      function updatePricePartial() {
        const selected = getSelectedVariantOptionsByIndex();

        if (!selected.some(Boolean) || !selectedVariantOptionsAreComplete(selected)) {
          priceEls.forEach(el => {
            el.innerHTML = defaultPriceHTML;
          });
          return;
        }

        const match = variants.find(v => arraysEqualCI(v.options, selected));

        if (!match) return;

        let html = "";

        if (
          match.formatted_compare_at_price &&
          Number(match.compare_at_price) > Number(match.price)
        ) {
          html = `
            <span class="price--compare"><s>${match.formatted_compare_at_price}</s></span>
            <span class="price--sale">${match.formatted_price}</span>
          `;
        } else {
          html = match.formatted_price || "";
        }

        priceEls.forEach(el => {
          el.innerHTML = html;
        });
      }

      /* ---------- Option buttons ---------- */
      optionBtns.forEach(btn => {
        btn.addEventListener("click", function() {
          const group = this.getAttribute("data-option-group");

          form.querySelectorAll(`.option-btn[data-option-group="${group}"]`).forEach(b => {
            b.classList.remove("active");
            b.setAttribute("aria-pressed", "false");
          });

          this.classList.add("active");
          this.setAttribute("aria-pressed", "true");

          if (group === "colorcount") {
            if (isSurpriseColourButton(this)) {
              resetColourCustomisation();
            } else {
              const count = getSelectedColourCount();
              renderSwatchSets(count);
              updateLivePreview();
            }
          }

          updateOptionAvailability();

          if (!getActiveColourCountButton()) {
            resetColourCustomisation();
          }

          updateVariantOptionPreviews();
          updatePricePartial();
          validate();
        });
      });

      /* ---------- Firmness ---------- */
      firmnessBtns.forEach(btn => {
        btn.addEventListener("click", function() {
          firmnessBtns.forEach(other => {
            other.classList.remove("active");
            other.setAttribute("aria-pressed", "false");
          });

          this.classList.add("active");
          this.setAttribute("aria-pressed", "true");

          if (propFirmness) {
            propFirmness.value = this.dataset.value || "";
          }

          validate();
        });
      });

      /* ---------- Swatches ---------- */
      swatchSetsContainer.addEventListener("click", function(e) {
        const sw = e.target.closest(".swatch");
        if (!sw) return;

        const setEl = sw.closest(".swatch-set");
        if (!setEl) return;

        const max = parseInt(setEl.dataset.maxSelect || "1", 10);

        if (sw.classList.contains("active")) {
          sw.classList.remove("active");
          sw.setAttribute("aria-pressed", "false");
        } else {
          if (max === 1) {
            setEl.querySelectorAll(".swatch.active").forEach(b => {
              b.classList.remove("active");
              b.setAttribute("aria-pressed", "false");
            });
          }

          if (setEl.querySelectorAll(".swatch.active").length < max) {
            sw.classList.add("active");
            sw.setAttribute("aria-pressed", "true");
          }
        }

        updateLivePreview();
        validate();

        const maxSel = parseInt(setEl.dataset.maxSelect || "1", 10);
        const chosen = setEl.querySelectorAll(".swatch.active").length;

        if (chosen >= maxSel && window.collapseSwatchSet) {
          setTimeout(() => window.collapseSwatchSet(setEl), 300);
        }

        setTimeout(() => {
          const btn = setEl.querySelector(".show-more-swatches");

          if (btn) {
            btn.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 500);
      });

      /* ---------- More info accordion ---------- */
      document.addEventListener("click", function(e) {
        const btn = e.target.closest(".variant-more-info-btn");
        if (!btn) return;

        const key = btn.dataset.info;
        const target = document.querySelector(`.variant-more-info-content[data-info-target="${key}"]`);

        if (!target) return;

        const isOpen = target.classList.contains("open");

        document.querySelectorAll(".variant-more-info-content").forEach(section => {
          section.classList.remove("open");
        });

        document.querySelectorAll(".variant-more-info-btn").forEach(b => {
          if (b.dataset.info === "pour-style") {
            b.textContent = window.customizerStrings.pour_show_example;
          } else {
            b.textContent = window.customizerStrings.more_info;
          }

          b.setAttribute("aria-expanded", "false");
        });

        if (!isOpen) {
          target.classList.add("open");

          if (btn.dataset.info === "pour-style") {
            btn.textContent = window.customizerStrings.pour_hide_example;
          } else {
            btn.textContent = window.customizerStrings.hide_info;
          }

          btn.setAttribute("aria-expanded", "true");
        }
      });

      hiddenInput.value = "";
      addToCartBtn.disabled = true;
      setCartVisibility(false);
      updateOptionAvailability();
      updateVariantOptionPreviews();
      validate();
    });
})();
